/* eslint-disable no-unused-vars */
import React, { useState, useEffect} from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Edit } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";
import SignatureD from "views/Signature/Signature";

import Parcel from "views/SubSignature/Parcel2568";
import GeneralAdministration from "views/SubSignature/GeneralAdministration2568.js";
import Pharmacy from "views/SubSignature/Pharmacy2568.js";
import Pathology from "views/SubSignature/Pathology2568.js";
import NursingScience from "views/SubSignature/NursingScience2568.js";
import OPD from "views/SubSignature/OPD2568.js";
import IPD from "views/SubSignature/IPD2568.js";
import Research from "views/SubSignature/Research2568.js";
import Digital from "views/SubSignature/Digital2568.js";
import HealthInsurance from "views/SubSignature/HealthInsurance2568.js";
import Quality from "views/SubSignature/Quality2568.js";
import CDOM from "views/SubSignature/CDOM2568";
import DSL from "views/SubSignature/DSL2568";
import axios from "axios";
import Edit2 from "views/SubSignature/Edit.js";
import Year from "views/Signature/Year.js";
import Goto from "views/SubSignature/Goto";

let ps;

const useStyles = makeStyles(styles);

export default function SubSignature({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [listTitle, setListTitle] = useState([]);
  const [selectedYear, setSelectedYear] = useState(2568);
  const [routes2, setRoutes2] = useState([]);

  const routes = [
    {
      name: "เลือกปี",
      icon: DesktopWindows,
      component: (props) => <Year {...props} onYearChange={handleYearChange} />,
      layout: "/subsignature",
      path: "/year",
    },
    {
      name: "แก้ไขรายละเอียด",
      icon: Edit,
      component: Edit2,
      layout: "/subsignature",
      path: "/edit2"
    },
    {
      name: "การลงนามคำรับรอง ฯ รองผู้อำนวยการ",
      icon: DesktopWindows,
      layout: "/signature",
      path: ""
    },
  ]
  

  useEffect(() => {
    axios
      .get("/api/v1/signature/title")
      .then((result) => {
        console.log("Raw data from API:", result.data.data); 
        const data = result.data.data;
        const filteredData = data.filter((item) => item.isDeputy === false);
        console.log("Filtered Data (IsDeputy = 0):", filteredData);
        
        // const componentMap = {
        //   5: (props) => <Parcel {...props} customData={selectedYear}/>,
        //   6: (props) => <GeneralAdministration {...props} customData={selectedYear} />,
        //   7: (props) => <Pharmacy {...props} customData={selectedYear} />,
        //   8: (props) => <Pathology {...props} customData={selectedYear} />,
        //   9: (props) => <CDOM {...props} customData={selectedYear} />,
        //   10: (props) => <DSL {...props} customData={selectedYear} />,
        //   11: (props) => <NursingScience {...props} customData={selectedYear} />,
        //   12: (props) => <OPD {...props} customData={selectedYear} />,
        //   13: (props) => <IPD {...props} customData={selectedYear} />,
        //   14: (props) => <Research {...props} customData={selectedYear} />,
        //   15: (props) => <Digital {...props} customData={selectedYear} />,
        //   16: (props) => <HealthInsurance {...props} customData={selectedYear} />,
        //   17:(props) => <Quality {...props} customData={selectedYear} />,
        // };
        
        
        const routes = filteredData.map((item) => ({
          name: item.titleName,
          icon: Edit,
          //component: (props) => <div>{item.titleName}</div>, 
          component: (props) => <SignatureD {...props} titleId={item.titleId} />, 
          //component: componentMap[item.titleId],
          layout: "/subsignature",
          path: `/title/${item.titleId}`, 
        }));
  
        setListTitle(filteredData);
        setRoutes2(routes); 
      })
      .catch((error) => {
        console.error("Error fetching titles:", error);
      });
  }, []);

    const filteredRoutes = React.useMemo(() => {
      return routes.concat(routes2);
    }, [selectedYear, routes2]);
  
  // const filteredRoutes = React.useMemo(() => {
  //   if (routes2.length === 0) {
  //     // Return empty array or loading state while waiting for routes2 to be updated
  //     return [];
  //   }
  //   return routes2;
  // }, [routes2]);


//const routes = [
  // {
  //   name: "หัวหน้ากลุ่มงานการเงิน บัญชีและพัสดุ",
  //   icon: Edit,
  //   component: Parcel,
  //   layout: "/subsignature",
  //   path: "/parcel"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานบริหารทั่วไป",
  //   icon: Edit,
  //   component: GeneralAdministration,
  //   layout: "/subsignature",
  //   path: "/generaladministration"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานเภสัชกรรม",
  //   icon: Edit,
  //   component: Pharmacy,
  //   layout: "/subsignature",
  //   path: "/pharmacy"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานพยาธิวิทยาคลินิกและเทคนิคการแพทย์",
  //   icon: Edit,
  //   component: Pathology,
  //   layout: "/subsignature",
  //   path: "/pathology"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานผื่นแพ้สัมผัสและอาชีวเวชศาสตร์",
  //   icon: Edit,
  //   component: CDOM,
  //   layout: "/subsignature",
  //   path: "/cdom"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานศัลยศาสตร์และเลเซอร์ผิวหนัง",
  //   icon: Edit,
  //   component: DSL,
  //   layout: "/subsignature",
  //   path: "/dsl"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานวิชาการพยาบาล",
  //   icon: Edit,
  //   component: NursingScience,
  //   layout: "/subsignature",
  //   path: "/nursingscience"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานการพยาบาลผู้ป่วยนอก",
  //   icon: Edit,
  //   component: OPD,
  //   layout: "/subsignature",
  //   path: "/opd"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานการพยาบาลผู้ป่วยใน",
  //   icon: Edit,
  //   component: IPD,
  //   layout: "/subsignature",
  //   path: "/ipd"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานวิจัย ถ่ายทอด และสนับสนุนวิชาการ",
  //   icon: Edit,
  //   component: Research,
  //   layout: "/subsignature",
  //   path: "/research"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานดิจิทัลการแพทย์",
  //   icon: Edit,
  //   component: Digital,
  //   layout: "/subsignature",
  //   path: "/digital"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานประกันสุขภาพ",
  //   icon: Edit,
  //   component: HealthInsurance,
  //   layout: "/subsignature",
  //   path: "/healthinsurance"
  // },
  // {
  //   name: "หัวหน้ากลุ่มงานพัฒนาคุณภาพ",
  //   icon: Edit,
  //   component: Quality,
  //   layout: "/subsignature",
  //   path: "/quality"
  // },
  // {
  //   name: "การลงนามคำรับรอง ฯ รองผู้อำนวยการ",
  //   icon: DesktopWindows,
  //   layout: "/signature",
  //   path: ""
  // }
//];

const switchRoutes = (
  <Switch>
    {filteredRoutes.map((prop, key) => {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}

    <Route path="/subsignature/id/:TitleId" component={Goto} />
    <Redirect from="/signature" to="/signature/year" />
    <Redirect from="/subsignature" to="/subsignature" />
  </Switch>
);

// const useStyles = makeStyles(styles);

// export default function SubSignature({ ...rest }) {
//   // styles
//   const classes = useStyles();
//   // ref to help us initialize PerfectScrollbar on windows devices
//   const mainPanel = React.createRef();
//   // states and functions
//   const [image, setImage] = React.useState(bgImage);
//   const [color, setColor] = React.useState("blue");
//   const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
//   const [mobileOpen, setMobileOpen] = React.useState(false);
 useEffect(() => {
    console.log("Selected Year changed to:", selectedYear);
  }, [selectedYear]);
  

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={filteredRoutes}
        logoText={"การลงนามคำรับรองฯ"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={filteredRoutes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}

